/**
 * Where a staff warning notification opens. The employee's (issued, a
 * reminder, withdrawn) open the warning; HR's (acknowledged) open that person's
 * Warnings tab on the staff profile. Shared by NotificationBell and
 * usePushNotifications so the two agree.
 */
export function staffWarningNotificationPath(type: string | undefined, data?: Record<string, string>): string | null {
  if (type === 'staff_warning_issued' || type === 'staff_warning_withdrawn') {
    return data?.warning_id ? `/my-warnings/${encodeURIComponent(data.warning_id)}` : '/my-warnings';
  }
  if (type === 'staff_warning_acknowledged') {
    return data?.userId ? `/hr/staff?tab=warnings&user=${encodeURIComponent(data.userId)}` : '/hr/staff?tab=warnings';
  }
  return null;
}
